// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"SignupPage-Wrapper-3E0Hx2","EmbedWrapper":"SignupPage-EmbedWrapper-tW1yA3 SignupPage-Wrapper-3E0Hx2","Content":"SignupPage-Content-2_Ovyj"};